// Package Imports
import React, { FunctionComponent } from 'react';

// Component Imports
import Pill from '../pill';

// Type Imports
import { Filter as FilterType, SelectedFilterProps } from '@/lib/types/filters';

// Config Imports
import { MERGE_FILTERS_MAP } from '@/lib/config/search/filterMergeMapping';

// Style Imports
import styles from './selectedFilter.module.scss';
import mainStyles from '../searchFilters.module.scss';

const SelectedFilter: FunctionComponent<SelectedFilterProps> = ({
  data,
  remove,
}) => {
  const removePill = (filter: FilterType) => {
    remove(filter);
  };

  const getMergedFilterLabel = (filter: FilterType): string => {
    const mergeMap = MERGE_FILTERS_MAP[filter.parameter];
    const fallbackName = filter.name ?? filter.value;

    if (!mergeMap) return fallbackName;

    for (const [mergedName, values] of Object.entries(mergeMap)) {
      if (values.includes(filter.value) || mergedName === filter.value) {
        return mergedName;
      }
    }

    return fallbackName;
  };

  const visibleFilters = data.filter(
    (filter) =>
      filter.parameter !== "price" &&
      filter.parameter !== "price_min" &&
      filter.parameter !== "price_max"
  );

  const deduplicated = new Map<string, FilterType>();
  visibleFilters.forEach((filter) => {
    const mergedName = getMergedFilterLabel(filter);
    const key = `${filter.parameter}:${mergedName}`;
    if (!deduplicated.has(key)) {
      deduplicated.set(key, { ...filter, name: mergedName, value: mergedName });
    }
  });

  return (
    <div className={mainStyles.wrapper}>
      <span className={mainStyles.title}>ACTIVE FILTERS</span>
      <div className={styles.wrapper}>
        {deduplicated.size > 0 ? (
          Array.from(deduplicated.values()).map((filter, i) => (
            <Pill key={`p-${i}`} data={filter} remove={removePill} />
          ))
        ) : (
          <span className={styles.noFilter}>No filters currently selected.</span>
        )}
      </div>
    </div>
  );
};

export default SelectedFilter;
